import React from "react"
import ProductSort from "@components/product/sorting"
import ItemsPerPageSelector from "@components/items-per-page-selector"

const ProductFiltersMobile = ({
  sortingOptions,
  setSortingOptions,
  itemsPerPage,
  setItemsPerPage,
  sortedProducts,
}) => {

  return (
    <div className="col-span-1 block md:hidden pt-5">
      <div className="flex gap-x-5">
        <ProductSort
          sortingOptions={sortingOptions}
          setSortingOptions={setSortingOptions}
        />
        <ItemsPerPageSelector
          setItemsPerPage={setItemsPerPage}
          itemsPerPage={itemsPerPage}
          sortedProducts={sortedProducts}
        />
      </div>
    </div>
  )
}

export default ProductFiltersMobile
